import { render, staticRenderFns } from "./ComInfo1.vue?vue&type=template&id=324be327&scoped=true&"
import script from "./ComInfo1.vue?vue&type=script&lang=js&"
export * from "./ComInfo1.vue?vue&type=script&lang=js&"
import style0 from "./ComInfo1.vue?vue&type=style&index=0&id=324be327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324be327",
  null
  
)

export default component.exports